import restaurantModalLoginInstance from '../../../modalLoginInstance'
import restaurantInstance from '../../../instance'

const moveOrderToKitchen = (tableId, data, hasModalLogin = true) => {
  return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
    .put(`/tables/${tableId}/items/moveToKitchen`, data)
}

export default moveOrderToKitchen
